<template>
  <el-dialog
    title="生成扣款计划失败通知"
    :visible.sync="dialogVisible"
    width="560px"
    :before-close="closeDialog"

  >
    <el-result icon="error" title="创建失败" subTitle="请根据提示进行操作"></el-result>
    <QS-h4-title title="应收ID" no-decorate>
      <span slot="right" :style="{fontSize:'16px'}">失败原因</span>
    </QS-h4-title>
    <ul class="list">
      <li class="item" v-for="item in errData" :key="item.accruedId">
        <span>{{item.accruedId}}</span>
        <span>{{item.reason}}</span>
      </li>
    </ul>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onOk">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    errData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogVisible: false,
      list: [1, 2],
    }
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false
    },
    onOk() {
      this.dialogVisible = false
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-result__title {
  font-size: 16px;
  margin-top: 16px;
}
ul {
  list-style: none;
  padding-inline-start: 0;
}
.list {
  width: 100%;
}
.item {
  display: flex;
  padding: 0 16px;
  height: 56px;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 1px 0px 0px #ebedf0, inset 0px -1px 0px 0px #ebedf0;
}
</style>
